<template>
  <div>
    <div v-loading="nalaganjeNovegaGesla" class="sprememba-gesla">
      <div class="postavitev-besedila">
        <p class="navadno-besedilo mobile-odmik">
          Varnost je na prvem mestu. Da bi ohranili varnost svojega T-2 uporabniškega računa,
          redno spreminjajte geslo in ga ne uporabljajte na drugih spletnih mestih.
        </p>
        <p v-if="zadnjaSprememba !== null && zadnjaSprememba.length > 10">
          <b>
            Geslo ste nazadnje spremenili {{zadnjaSprememba.substring(0, 10)}}.
          </b>
        </p>
      </div>
      <div class="postavitev-input">
        <el-form
          label-width="155px"
          @submit.native.prevent="ShraniNovoGeslo"
          :label-position="formaOrientacija"
          class="nova-vrstica-forma custom-labels">
          <el-form-item label="T-2 uporabniški račun">
            <el-input placeholder="" v-model="email" :disabled="true"
                      class="pozicija-uporabniski-racun"/>
          </el-form-item>
          <el-form-item label="Trenutno geslo">
            <el-input placeholder="Vnesite trenutno geslo" type="password" v-model="trenutnoGeslo"
                      class="pozicija-trenutno-geslo">
            </el-input>
          </el-form-item>
          <el-form-item label="Novo geslo" style="label: none;">
            <el-input placeholder="Vnesite novo geslo" type="password" v-model="novoGeslo"
                      class="pozicija-novo-geslo" value="FakePSW" id="input-novo-geslo">
              <i slot="suffix" class="fa fa-eye-slash" id="ikonaEyeSlashNovoGeslo"
                 @click="PrikazGesel('input-novo-geslo')" v-if="prikazeIkonoNovoGeslo">
              </i>
              <i slot="suffix" class="fa fa-eye" id="ikonaEyeNovoGeslo"
                 @click="PrikazGesel('input-novo-geslo')" v-else>
              </i>
            </el-input>
          </el-form-item>
          <el-form-item class="potrjeno-geslo" label="Potrdite novo geslo">
            <el-input placeholder="Ponovno vnesite novo geslo" type="password" v-model="potrjenoGeslo"
                      class="pozicija-potrjeno-geslo" value="FakePSW"
                      id="input-ponovite-geslo">
              <i slot="suffix" class="fa fa-eye-slash" id="ikonaEyeSlashPonoviteGeslo"
                 @click="PrikazGesel('input-ponovite-geslo')" v-if="prikazeIkonoPonoviteGeslo">
              </i>
              <i slot="suffix" class="fa fa-eye" id="ikonaEyePonoviteGeslo"
                 @click="PrikazGesel('input-ponovite-geslo')" v-else>
              </i>
            </el-input>
            <validacija-vrednosti
              v-if="!statusValidacije"
              class="mobile-pozicija"
              :prva-vrednost="novoGeslo"
              :druga-vrednost="potrjenoGeslo"
              :style=" potrjenoGeslo ? 'margin-top:0':'margin-top:-45px'"
              v-on:ValidacijaStatus="SpremeniStatus"/>
          </el-form-item>
        </el-form>
      </div>
      <div style="padding-top: 40px;">
        <el-button type="primary" @click="ShraniNovoGeslo" class="gumb-potrdi">
          SPREMENI GESLO
        </el-button>
      </div>
    </div>
    <hr class="hr-stil"/>
    <div v-loading="pridobivanjeOsebnihPodatkov">
      <div class="postavitev-vsebine-dvostopenjska-zascita">
        <span class="open-sans-20pt">
          Dvostopenjska zaščita z SMS geslom
        </span>
        <p class="navadno-besedilo novi-odstavek">
          <span>
            Dodatno zaščitite svoj T-2 račun z vklopom dvostopenjske zaščite.
            Z vklopom bo vklopljeno dvojno preverjanje, kar pomeni, da boste ob vpisu z geslom ali
          </span>
          <br/>
          <span>
            Facebook/Google računom morali vpisati še SMS geslo, ki ga boste prejeli ob prijavi.
          </span>
          <span>
            S tem bodo vaš T-2 račun in podatki dodatno zaščiteni.
          </span>
        </p>
      </div>
      <p v-if="osebniPodatkiTelefonskaStevilka !== ''" class="navadno-besedilo novi-odstavek telefon-narocnika">
        Telefonska številka T-2 računa:
        <b style="color: #f58220">
          {{ izpisOsebneStevilke }}
        </b>
      </p>
      <div v-if="this.osebniPodatkiTelefonskaStevilka === ''" style="padding-top: 20px">
        <div>
          <b>
            <i style="width: 20px; height: 20px; color: #080809;" class="fa">
              &#xf071;
            </i>
            STATUS:
          </b>
          Za vklop zaščite, prosimo, dopolnite mobilno številko v
          <a href="/Mojprofil/Osnovno" class="primarna-barva "
             target="_blank">
            vašem profilu</a>.
        </div>
      </div>
      <div v-if="this.osebniPodatkiTelefonskaStevilka !== ''">
        <el-form
          label-width="230px"
          :label-position="formaOrientacija"
          @submit.native.prevent="PreveriTelefonskoStevilko">
          <el-checkbox v-if="preverjanje" class="vklopIzklop" :value="preverjanje" @change="pokaziObvestiloAliPreklici">
            Vklopi dvostopenjsko zaščito
          </el-checkbox>
          <el-checkbox v-else class="vklopIzklop" :value="preverjanje" @change="VklopIzklopDvostopenjskeZascite">
            Vklopi dvostopenjsko zaščito
          </el-checkbox>
          <div v-if="this.preverjanje === true && this.osebniPodatkiSmsTokenLogin === false &&
            this.osebniPodatkiTelefonskaStevilka.length > 0">
            <p class="navadno-besedilo">
              Na vašo telefonsko številko smo poslali SMS geslo. Vpišite ga spodaj.
            </p>
            <el-input
              class="velikost-input pozicija-sms-geslo"
              placeholder="SMS geslo"
              type="text"
              v-model="smsToken">
            </el-input>
            <span class="pozabljenoGeslo">
            <img src="/static/img/Domov/Icon-awesome-exclamation-triangle-black.png">
            <label>Niste prejeli gesla?</label>
            <a @click="PosljiPotrditveniSms" style="cursor: pointer">
              Pošlji ponovno.
            </a>
          </span>
            <div>
              <el-button type="primary" @click="PreveriTelefonskoStevilko" class="gumb-potrdi odmik-zgoraj">
                POTRDI SMS GESLO
              </el-button>
              <a class="stil-gumb-preklici" @click="Preklici" type="primary">
                PREKLIČI
              </a>
            </div>
          </div>
          <div v-else class="shrani-spremembe">
            <p v-if="osebniPodatkiSmsTokenLogin === true">
              <i class="el-icon-check"/>
              STATUS: Dvostopenjska zaščita z SMS geslom je
              {{ osebniPodatkiSmsTokenLogin ? 'vklopljena' : 'izklopljena' }}
            </p>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import {PridobiStranko} from 'src/assets/js/globalne_funkcije/PridobivanjeStranke/PridobiStranko'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import Vue from 'vue'
import {
  Table, Checkbox, TableColumn, Input, Button, Form, FormItem, Option, Collapse, CollapseItem, Select, Loading,
  Pagination, MessageBox
} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import ValidacijaVrednosti from './ValidacijaVrednosti'
import {
  FormatirajTelefonskoStevilko
} from '../../../../../assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke'
import {FormatDatuma} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormatDatuma'

Vue.use(Pagination)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Form)
Vue.use(Checkbox)
Vue.use(FormItem)
Vue.use(Loading)
export default {
  name: 'SpremembaGesla',
  mixins: [PrikazVsebine, PridobiStranko, FormatirajTelefonskoStevilko],
  data () {
    return {
      email: '',
      trenutnoGeslo: '',
      novoGeslo: '',
      potrjenoGeslo: '',
      clientAgent: null,
      nalaganjeNovegaGesla: false,
      formaOrientacija: 'left',
      prikazeIkonoPonoviteGeslo: true,
      prikazeIkonoNovoGeslo: true,
      mejnaSirina: 700,
      smsToken: '',
      preverjanje: false,
      osebniPodatkiTelefonskaStevilka: '',
      pridobivanjeOsebnihPodatkov: true,
      osebniPodatkiSmsTokenLogin: false,
      zadnjaSprememba: null,
      statusValidacije: false
    }
  },
  components: {
    ValidacijaVrednosti,
    [Button.name]: Button,
    [Input.name]: Input,
    [Form.name]: Form,
    [Option.name]: Option,
    [Select.name]: Select,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Pagination.name]: Pagination,
    PridobiStranko
  },

  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetOsnovneInformacijeUporabnika()
    this.GetUserData()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    SpremeniStatus (e) {
      this.statusValidacije = e
    },
    Preklici () {
      this.preverjanje = false
      let paramObvestilo = {}
      paramObvestilo.message = 'Zahteva uspešno preklicana.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    PrenosniPodatkiStranka (osebnikPodatki, nalaganje) {
      this.osebniPodatkiTelefonskaStevilka = ''
      this.osebniPodatkiSmsTokenLogin = ''
      this.osebniPodatkiTelefonskaStevilka = osebnikPodatki.phone
      this.izpisOsebneStevilke = this.VrniFormatUmtsStevilke(osebnikPodatki.phone)
      this.osebniPodatkiSmsTokenLogin = osebnikPodatki.smsTokenLogin
      this.preverjanje = this.osebniPodatkiSmsTokenLogin
      this.pridobivanjeOsebnihPodatkov = nalaganje
    },
    VklopIzklopDvostopenjskeZascite (val) {
      if (val) {
        this.preverjanje = true
        this.PosljiPotrditveniSms()
      } else {
        if (this.osebniPodatkiSmsTokenLogin === true) {
          MessageBox.confirm(
            'Ali ste prepričani, da želite izklopiti dvostopenjsko zaščito?', {
              confirmButtonText: 'Da',
              cancelButtonText: 'Prekliči',
              confirmButtonClass: 'gumb-potrdi',
              cancelButtonClass: 'gumb-preklici',
              customClass: 'opozorilo-dialog'
            }).then(() => {
            this.PreverjanjeDvostopenjskeZascite(0)
          }).catch((err) => {
            err = null
            this.GetUserData()
            this.preverjanje = !this.preverjanje
          })
        }
      }
    },
    pokaziObvestiloAliPreklici (val) {
      if (this.osebniPodatkiSmsTokenLogin && !val) {
        this.VklopIzklopDvostopenjskeZascite(false)
      } else {
        let paramObvestilo = {}
        paramObvestilo.message = 'Za preklic aktivacije dvostopenjske zaščite kliknite PREKLIČI.'
        this.ShowWarningMessage(paramObvestilo)
      }
    },
    PrikazGesel (id) {
      let element = document.getElementById(id)
      if (element.type === 'password') {
        element.type = 'text'
        if (id === 'input-novo-geslo') {
          this.prikazeIkonoNovoGeslo = false
        } else {
          this.prikazeIkonoPonoviteGeslo = false
        }
      } else {
        element.type = 'password'
        if (id === 'input-novo-geslo') {
          this.prikazeIkonoNovoGeslo = true
        } else {
          this.prikazeIkonoPonoviteGeslo = true
        }
      }
    },
    ShraniNovoGeslo () {
      this.nalaganjeNovegaGesla = true
      if (this.novoGeslo === this.potrjenoGeslo) {
        let param = ['oldPassword=' + this.trenutnoGeslo]
        param.push('password=' + this.novoGeslo)
        if (this.novoGeslo === '') {
          let paramObvestilo = {}
          paramObvestilo.message = 'Niste vnesli novih podatkov.'
          this.ShowWarningMessage(paramObvestilo)
          this.nalaganjeNovegaGesla = false
        } else if (this.trenutnoGeslo.length === 0) {
          let paramObvestilo = {}
          paramObvestilo.message = 'Niste vnesli trenutnega gesla.'
          this.ShowWarningMessage(paramObvestilo)
          this.nalaganjeNovegaGesla = false
        } else if (this.novoGeslo.length < 8) {
          let paramObvestilo = {}
          paramObvestilo.message = 'Novo geslo mora imeti vsaj 8 znakov.'
          this.ShowWarningMessage(paramObvestilo)
          this.nalaganjeNovegaGesla = false
        } else {
          this.clientAgent.postWsRequest(
            this,
            'user/changePassword?',
            param,
            null,
            'SetNovoGesloShranjeno',
            'SetNapakaPriShranjevanju')
        }
      } else {
        let paramObvestilo = {}
        paramObvestilo.message = 'Gesli se ne ujemata.'
        this.ShowWarningMessage(paramObvestilo)
        this.nalaganjeNovegaGesla = false
      }
    },
    SetNovoGesloShranjeno (podatki) {
      if (podatki.status === 1) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Geslo uspešno posodobljeno.'
        this.ShowSuccessMessage(paramObvestilo)
        this.GetOsnovneInformacijeUporabnika()
        this.nalaganjeNovegaGesla = false
      }
    },
    SetNapakaPriShranjevanju (podatki) {
      this.ShowWarningMessage(podatki)
      this.nalaganjeNovegaGesla = false
    },
    GetOsnovneInformacijeUporabnika () {
      let param = []
      this.clientAgent.postWsRequest(
        this,
        'user/info?',
        param,
        null,
        'SetOsnovneInformacijeUporabnika',
        'ErrMessage')
    },
    SetOsnovneInformacijeUporabnika (podatki) {
      this.email = podatki.email
      this.zadnjaSprememba = podatki.passwordLastSetDate !== null
        ? FormatDatuma.methods.PoenotenIzgledDatuma(podatki.passwordLastSetDate) : null
    },
    PreverjanjeDvostopenjskeZascite (status) {
      let param = []
      param.push('enabled=' + status)
      this.preverjanje = false
      this.clientAgent.postWsRequest(
        this,
        'user/editSmsTokenLogin?',
        param,
        null,
        'SetPreverjanjeDvostopenjskeZascite',
        'ErrMessage')
    },
    SetPreverjanjeDvostopenjskeZascite () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Dvostopenjska zaščita z SMS geslom uspešno posodobljeno.'
      this.ShowSuccessMessage(paramObvestilo)
      this.preverjanje = true
      this.GetUserData()
    },
    PreveriTelefonskoStevilko () {
      let param = ['token=' + this.smsToken]
      this.clientAgent.postWsRequest(
        this,
        'user/verifyPhoneNumber?',
        param,
        null,
        'SetPreveriTelefonskoStevilko',
        'ErrMessage')
    },
    SetPreveriTelefonskoStevilko (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = 'Telefonska številka je bila uspešno preverjena.'
      this.ShowSuccessMessage(paramObvestilo)
      this.PreverjanjeDvostopenjskeZascite(1)
    },
    PosljiPotrditveniSms () {
      let param = []
      this.clientAgent.postWsRequest(
        this,
        'user/sendVerificationSms?',
        param,
        null,
        'SetPosljiPotrditveniSms',
        'ErrMessage')
    },
    SetPosljiPotrditveniSms () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno poslan SMS s potrditvenim geslom.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrMessage (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}
</script>

<style>
/deep/ .el-table th > .cell {
  font-weight: bold;
  color: #080809;
}
</style>
<style scoped src="../../../../../../static/css/moj_profil/varnost.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/Varnost/SpremembaGesla.vue